import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Kfh_PropertyTypeInterface } from '../../types/graphqlTypes';
import { Typography } from '../Typography';

interface PropertyMetaProps {
  property: Kfh_PropertyTypeInterface;
  propertyCard?: boolean;
}

// Styles

const StyledPropertyMeta = styled(Typography)`
  ${({ theme: { space } }) => css`
    strong {
      display: block;
      margin-bottom: ${space.xxs};
    }
  `};
`;

const StyledMetaItem = styled.span`
  ${({ theme: { maxMedia } }) => css`
    //white-space: nowrap;
  `};
`;

// JSX

const PropertyMeta: FC<PropertyMetaProps> = ({ property, propertyCard, ...rest }) => {
  // Categorisation

  const isCommercial = property.commercial;

  return (
    <StyledPropertyMeta component="p" variant={propertyCard ? 'bodySmall' : 'bodyLarge'} {...rest}>
      <strong>
        {property.propertyStyle && <>{property.propertyStyle} - </>}
        {property.propertyType && <>{!isCommercial ? property.propertyType.toLowerCase() : property.propertyType} /</>}
        {property.propertySubType && (
          <> {!isCommercial ? property.propertySubType.toLowerCase() : property.propertySubType} /</>
        )}
        {property.tenure && <> {property.tenure.toLowerCase()} </>}
        {property.furnished && <> {property.furnished.toLowerCase()} </>}
      </strong>{' '}
      {property.bedrooms > 0 && (
        <StyledMetaItem>
          {property.bedrooms} bedroom{property.bedrooms !== 1 && 's'}
          {', '}
        </StyledMetaItem>
      )}
      {property.receptions > 0 && (
        <StyledMetaItem>
          {property.receptions} reception{property.receptions !== 1 && 's'}
          {', '}
        </StyledMetaItem>
      )}
      {property.bathrooms > 0 && (
        <StyledMetaItem>
          {property.bathrooms} bathroom{property.bathrooms !== 1 && 's'}
        </StyledMetaItem>
      )}
      {isCommercial && (
        <StyledMetaItem>
          {property.roomMetrics} m<sub>2</sub> ({property.roomImperials} ft<sub>2</sub>)
        </StyledMetaItem>
      )}
    </StyledPropertyMeta>
  );
};

export default PropertyMeta;
